import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { CheckPageAccess } from 'src/app/components/authorize/check-page-access';
import { NoResultsComponent } from 'src/app/components/no-results/no-results.component';
import { TagList, TagListDefaultValues } from 'src/app/components/tags/tag-list';
import { TagQueryFilter, TagQueryFilterDefaultValues } from 'src/app/components/tags/tag-query-filter';
import { AuthService } from 'src/app/services/auth.service';
import { TagsService } from 'src/app/services/tag-service.service';

@Component({
    selector: 'app-tag-list',
    templateUrl: './tag-list.component.html',
    styleUrls: ['./tag-list.component.scss'],
    standalone: false
})
export class TagListComponent {

  totalRecords: number = 0;
  tags: TagList[] = [];
  columnsToDisplay = [
    'Tag','Category', 'Status',
  ]
  queryFilter:TagQueryFilter=TagQueryFilterDefaultValues();
  pageEvent!: PageEvent;
  @ViewChild('paginator') paginator!: MatPaginator;
  @ViewChild('noResults') noResults!: NoResultsComponent;
  @ViewChild('submitButton') submitButton !:ElementRef
  tagCategory:any[]=[];
  information: string='';
  pageName = CheckPageAccess.TAGS
  showAddButton=this.authservice.getAccessControl().addTags;
  constructor(public tagService:TagsService,private authservice:AuthService){

  }
  async ngOnInit(): Promise<void> {
    this.information="<h4>Status Definitions</h4><br/><span>Active:</span> Tag is finalized and available for use and can be edited at any time.<br/><br/><span>Inactive:</span> Tag is no longer actively used for courses."
    await this.tagService.getAllCategories().subscribe({
      next: (data) => {
        this.tagCategory = data
      }
    })

    this.searchWithFilters();
  }
  handlePageEvent(e: PageEvent) {
    this.pageEvent = e;
    this.queryFilter.PageNumber = e.pageIndex
    this.queryFilter.PageSize = e.pageSize
    this.searchWithFilters();
  }

  private searchWithFilters() {

    this.tagService.getAllTags(this.queryFilter).subscribe({
      next: (data) => {
        let headers = data.headers.get('x-pagination');
        if (headers) {
          let parsedHeaders = JSON.parse(headers);
          this.totalRecords = parsedHeaders.TotalCount;
          console.log(this.totalRecords);
          this.noResults.setTotal(this.totalRecords);
        }
        this.tags = data.body ? data.body : [];
      },
      error: (error) => {
        console.log(error);
      },
      complete: () => { }
    });
  }

  @HostListener('document:keypress', ['$event'])
	handleKeyboardEvent(event: KeyboardEvent): void {
	  if (event.key === 'Enter') {
		this.submitButton.nativeElement.click();
		event.preventDefault();
	  }
	}

  resetFilters() {
   this.queryFilter = TagQueryFilterDefaultValues()
   this.search();
  }

  search() {
    this.searchWithFilters();
    }
}
